import { ConfigService } from './services/config.service';

export function appConfigFactory(configService: ConfigService) {
  return () => configService.loadAppConfig();
}
